import React from 'react';
import { Link } from 'react-router-dom';

import {
    Button,
    GradientColumn,
    IconRightArrow,
    IconTrqkLogo,
    SingerBackground,
} from '@trqk/components';

import { PATHS } from '../../constants';

const centerColumnMinWidth = 550;
const sidebarWidth = 550;

/**
 * Shows a "Not Found" i.e. 404 message. Shows a link to the sign in page, which will redirect the
 * user to the Insights page if they are already signed in.
 */
export const NotFound = (): JSX.Element => (
    <SingerBackground>
        <div className="w-screen h-screen">
            <div className="flex justify-between h-screen">
                <div className="flex-initial flex-col flex items-center p-8">
                    <div className="pl-1">
                        <IconTrqkLogo
                            fillColor="black"
                            width={72}
                            opacity={1}
                        />
                    </div>
                </div>
                <div
                    className="flex-auto flex flex-col justify-between h-full"
                    style={{ minWidth: centerColumnMinWidth }}
                >
                    <div className="flex-auto pl-12 border-l border-solid border-quarternary-100 text-xs pt-12" />
                    <div className="flex-initial flex">
                        <div className="border-l-4 border-solid border-secondary-500 rounded-full" />
                        <div className="ml-12">
                            <h1>Not Found</h1>
                        </div>
                    </div>
                    <div className="flex-auto pl-12 border-l border-solid border-quarternary-100 pt-4">
                        <p className="leading-loose">
                            It looks like you&rsquo;ve requested a page that
                            doesn&rsquo;t exist.
                        </p>
                        <div className="w-auto inline-block pt-8">
                            <Link to={PATHS.SIGN_IN}>
                                <Button color="tertiary" boxShadow={true}>
                                    <span className="pr-32">Back to Trqk</span>
                                    <IconRightArrow fillColor="white" />
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <div className="flex-auto border-l border-solid border-quarternary-100" />
                </div>
                <div
                    className="flex-none pl-4 opacity-75"
                    style={{ width: sidebarWidth }}
                >
                    <GradientColumn color="purple" />
                </div>
            </div>
        </div>
    </SingerBackground>
);
